import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=764b1f0f&scoped=true&"
import script from "./strategy.vue?vue&type=script&lang=js&"
export * from "./strategy.vue?vue&type=script&lang=js&"
import style0 from "./strategy.vue?vue&type=style&index=0&id=764b1f0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764b1f0f",
  null
  
)

export default component.exports